/**
 * Log repetitive XMLHTTPRequests to New Relic for tracking.
 */
// @ts-expect-error ts-migrate(6133) FIXME: 'global' is declared but its value is never read.
(function _AjaxLogger(global) {
  const _urlCache = {};

  /**
   * Callback for every AJAX done through jQuery, for logging repetitive
   * queries to New Relic.
   * @param {Event} event
   * @param {jqXHR} jqxhr
   * @param {Object} settings
   * @private
   */
  function _ajaxLoggerHandler(_event: TSFixMe, _jqxhr: TSFixMe, settings: TSFixMe) {
    // Remove the no_cache param from the URL
    const url = settings.url.replace(/(\??)&?no_cache=[0-9]+/, '$1');

    // eg. "POST:/foo/bar?q=1:{baz:qux}"

    const key = `${settings.type}:${url}:${settings.data}`;

    const now = new Date();

    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (!_urlCache[key]) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _urlCache[key] = [];
    }

    // Loop our entries for this key, and remove expired ones
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    while (_urlCache[key].length && (now as any) - _urlCache[key][0].t > 60000) {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      _urlCache[key].shift();
    }

    // Now add the new data
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    _urlCache[key].push({ t: now });

    // For every 5th time we call the same URL, log it to New Relic
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (_urlCache[key].length % 5 === 0 && window.newrelic) {
      window.newrelic.addPageAction('repetitive-ajax', { pageUrl: url });
    }

    // Also log to console if repetitive at all (more than 1 call per 60s)
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    if (_urlCache[key].length > 1) {
      window.merchantos.debug(
        `Repetitive AJAX event: ${
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          _urlCache[key].length
        } times. Data: ${key}`
      );
    }
  }

  /**
   * Purge expired entries from _urlCache.
   * @private
   */
  function _cleanupLogs() {
    const now = new Date();

    let key;

    // eslint-disable-next-line no-restricted-syntax
    for (key in _urlCache) {
      // eslint-disable-next-line no-prototype-builtins
      if (_urlCache.hasOwnProperty(key)) {
        // Loop our entries for this key, and remove expired ones
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        while (_urlCache[key][0] && (now as any) - _urlCache[key][0].t > 60000) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          _urlCache[key].shift();
        }

        // Completely delete this key if it has no entries anymore
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        if (!_urlCache[key].length) {
          // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
          delete _urlCache[key];
        }
      }
    }
  }

  // Bind to all calls
  $(document).ajaxSend(_ajaxLoggerHandler);

  // Clean up expired ones every 60s
  setInterval(_cleanupLogs, 60000);
})(window);
